import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../constants';

export const usePersonDetailViewStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: COLORS.cardBg,
    border: `1px solid ${COLORS.border}`,
    borderRadius: 8,
    padding: theme.spacing(2),
  },
  header: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(2),
  },
  section: {
    borderTop: `1px dashed ${COLORS.border}`,
    marginTop: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  sectionHeader: {
    alignItems: 'center',
    display: 'flex',
    justifyContent: 'space-between',
    marginBottom: theme.spacing(1),
  },
  sectionEmpty: {
    color: COLORS.muted,
  },
  rowChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: theme.spacing(1),
  },
}));
